export default __webpack_public_path__ + "static/media/img-intro-overview-en.1fb19a7a.png";